
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ExecutionReportDetails from './executionReportDetails';
import { getArtifactDetails, getADVersionForArtifacts, getTicketIdsForArtifacts, getDatesForArtifacts } from './../../UserFunctions';
import React, { Component } from 'react';
import Select from 'react-select';
import Breadcrumb from 'react-bootstrap/Breadcrumb'

class ArtifactDashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            executionReportInfo: {},
            date: '',
            ad_version: '',
            kpi_status: '',
            id: '',
            date_list: [],
            ad_version_list: [],
            kpi_status_list: [],
            id_list: []
        }
    }

    //
    //Function called after component is mounted
    //
    componentDidMount() {
        getDatesForArtifacts().then((response) => {
            console.log(response)

            if (response && response.status === 200) {
                console.log("response date", response)
                const dates = response['data']['date_list'];
                const uniquedate = [...new Set(dates)];
                const organizedTags = uniquedate.map((item, index) => {
                    return {
                        label: item,
                        value: index
                    }
                })
                this.setState({ date_list: organizedTags })
            }
            console.log("tagNames date", this.state.date_list)
        })



        getADVersionForArtifacts().then((response) => {
            console.log(response)

            if (response && response.status === 200) {
                console.log("response ad version", response)
                const ad_versions = response['data']['ad_version_list'];
                console.log(ad_versions)
                const unique_ad_versions = [...new Set(ad_versions)];
                const organizedAdVersions = unique_ad_versions.map((item, index) => {
                    return {
                        label: item,
                        value: index
                    }
                })
                this.setState({ ad_version_list: organizedAdVersions })
            }
        })

        getTicketIdsForArtifacts().then((response) => {
            console.log(response)

            if (response && response.status === 200) {
                console.log("response ticket id", response)
                const id_list = response['data']['id_list'];
                console.log(id_list)
                const unique_id_list = [...new Set(id_list)];
                const organizedTicketID = unique_id_list.map((item, index) => {
                    return {
                        label: item,
                        value: index
                    }
                })
                this.setState({ id_list: organizedTicketID })
            }
        })


        const kpi_status = ["pass", "fail"]
        const unique_kpi_status = [...new Set(kpi_status)];
        const organizedKpiStatus = unique_kpi_status.map((item, index) => {
            return {
                label: item,
                value: index
            }
        })
        this.setState({ kpi_status_list: organizedKpiStatus })
        // this.state.kpi_status_list = organizedKpiStatus
    }

    onDateChange = (date) => {
        this.setState({ date: date.label })
    }

    onAdVersionChange = (ad_version) => {
        this.setState({ ad_version: ad_version.label })
    }
    onKpiStatusChange = (kpi_status) => {
        this.setState({ kpi_status: kpi_status.label })
    }

    onTicketIdChange = (id) => {
        this.setState({ id: id.label })
    }
    onMultiFilterChange = () => {
        let multiFilterArray = []
        if (this.state.date !== '') {
            multiFilterArray[0] = this.state.date
        }
        else {
            multiFilterArray[0] = "None"
        }
        if (this.state.ad_version !== '') {
            multiFilterArray[1] = this.state.ad_version
        }
        else {
            multiFilterArray[1] = "None"
        }
        if (this.state.kpi_status !== '') {
            multiFilterArray[2] = this.state.kpi_status
        }
        else {
            multiFilterArray[2] = "None"
        }
        if (this.state.id !== '') {
            multiFilterArray[3] = this.state.id
        }
        else {
            multiFilterArray[3] = "None"
        }
        const payload = {
            id: multiFilterArray[3],
            kpi_status: multiFilterArray[2],
            ad_version: multiFilterArray[1],
            date: multiFilterArray[0]
        }
        console.log(payload)
        getArtifactDetails(payload).then((response) => {
            console.log(response.data)
            if (response && response.status === 200) {
                if(response.data['artifacts'] === "None"){
                    alert("Please select atleast one filter option")
                }
                else{
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            executionReportInfo: response.data['artifacts']
                        }
                    })
                }
            }
            else {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        executionReportInfo: {}
                    }
                })
            }
        });
        console.log("executionReportInfo----------->", this.state.executionReportInfo)
    }
    render() {
        return (
            <div data-test='closedLoopPerformanceReportLandingComponent' className='container-fluid'>
                <Breadcrumb>
                    <Breadcrumb.Item href="">
                        <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        <Link to='/welcome'>Welcome</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=""  >
                        <Link to='/close_loop'>Close loop</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="/close_loop/artifact_dashboard" active >
                        Artifact Dashboard
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className='row' style={{ paddingTop: '4%' }}>
                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                <div className='row align-items-center'>
                                    <div className='col-10'>
                                        <h2>Artifact Dashboard</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-3'>
                                        <div className='card'>
                                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                <div className='row'>
                                                    <div className='col-12 align-self-center'>
                                                        <h5> Date of Execution</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                <Select
                                                    onChange={(date) => { this.onDateChange(date) }}
                                                    value={{ label: this.state.date }}
                                                    options={this.state.date_list}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-3'>
                                        <div className='card'>
                                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                <div className='row'>
                                                    <div className='col-12 align-self-center'>
                                                        <h5>AD version Name</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                <Select
                                                    value={{ label: this.state.ad_version }}
                                                    onChange={(ad_version) => { this.onAdVersionChange(ad_version) }}
                                                    options={this.state.ad_version_list}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-3'>
                                        <div className='card'>
                                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                <div className='row'>
                                                    <div className='col-12 align-self-center'>
                                                        <h5>KPI Status</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                <Select
                                                    value={{ label: this.state.kpi_status }}
                                                    onChange={(kpi_status) => { this.onKpiStatusChange(kpi_status) }}
                                                    options={this.state.kpi_status_list}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-3'>
                                        <div className='card'>
                                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                <div className='row'>
                                                    <div className='col-12 align-self-center'>
                                                        <h5>Initiated By</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body'>
                                                <Select
                                                    value={{ label: this.state.id }}
                                                    onChange={(id) => { this.onTicketIdChange(id) }}
                                                    options={this.state.id_list}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row' style={{ paddingTop: "2%" }}>
                                    <div className='col-12'>

                                        <div className='card'>
                                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                <h5>Execution Details

                                                    <button
                                                        type='submit'
                                                        style={{
                                                            backgroundColor: '#FFFFFF',
                                                            color: '#757AF7',
                                                            float: 'right'
                                                            
                                                        }}
                                                        onClick={this.onMultiFilterChange}
                                                        data-test="clickComponent"
                                                    >Show Results
                                                    </button>
                                                </h5>

                                            </div>
                                            <div className='card-body'>
                                                <ExecutionReportDetails
                                                    executionInfo={this.state.executionReportInfo}
                                                />
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect()(ArtifactDashboard);